import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["addLocationSection"];

  handleAddLocationClick = (event) => {
    event.preventDefault();
    const id_prefix = "new_location";
    let values = {};

    const selectedLocationCategoryElement = document.querySelector('input[name="new_location[office_pickup_category]"]:checked');
    const selectedLocationCategory = selectedLocationCategoryElement?.value;

    if (selectedLocationCategory === "School" || selectedLocationCategory === "Pick-up points") {
      const pointIdField = selectedLocationCategory === "School"
        ? document.querySelector('input[name="new_location[pick_up_high_school_id]"]')
        : document.querySelector('input[name="new_location[pick_up_pick_up_point_id]"]');
      const pointId = pointIdField?.value?.trim();
      if (!pointId) return;

      const idPrefix = selectedLocationCategory === "School" ? "school-pick-up" : "pick-up";
      const panel = document.getElementById(`${idPrefix}-points-${pointId}`);
      if (!panel) return;

      values = {
        label: panel.dataset.pointName || "",
        address: panel.dataset.pointAddress || "",
        postcode: panel.dataset.pointZipcode || "",
        address_line_2: "",
        city: "",
        state: "",
        country: "",
        note: document.getElementById(`${id_prefix}_note`)?.value || ""
      };
    } else {
      values = {
        address: document.getElementById(`${id_prefix}_address`)?.value ?? "",
        address_line_2: document.getElementById(`${id_prefix}_address_line_2`)?.value ?? "",
        city: document.getElementById(`${id_prefix}_city`)?.value ?? "",
        state: document.getElementById(`${id_prefix}_state`)?.value ?? "",
        postcode: document.getElementById(`${id_prefix}_zipcode`)?.value ?? "",
        country: document.getElementById(`${id_prefix}_country`)?.value ?? "",
        note: document.getElementById(`${id_prefix}_note`)?.value ?? ""
      };
    }

    const hiddenAddButton = document.getElementById("hidden-add-button");
    if (hiddenAddButton) hiddenAddButton.click();

    setTimeout(() => {
      const container = document.getElementById("locations-list");
      if (!container) return;
      const newRow = container.lastElementChild;
      if (!newRow) return;

      Object.keys(values).forEach((key) => {
        const input = newRow.querySelector(`[name$="[${key}]"]`);
        if (input) {
          input.value = values[key] ?? "";
          input.dispatchEvent(new Event("input", { bubbles: true }));
        }
      });

      this.resetWidget(id_prefix);
    }, 50);
  };

  resetWidget(id_prefix) {
    const fieldNames = ['address', 'address_line_2', 'city', 'state', 'zipcode', 'note'];
    fieldNames.forEach(fieldName => {
      const element = document.getElementById(`${id_prefix}_${fieldName}`);
      if (element) element.value = "";
    });

    this.addLocationSectionTarget.querySelectorAll('input[type="hidden"]').forEach(input => input.value = "");

    this.addLocationSectionTarget.querySelectorAll("[id^='pick-up-points-'], [id^='school-pick-up-points-']").forEach((el) => {
      el.classList.add("Panel--subtle");
    });
  }
}
